// C2 마물 전투 연출 색: 지역(서리/독/모래/심연) 원소 색과 정예 접두 고유색. 보스 공격 라이브러리도 같은 표를 쓴다.
// ART-BIBLE 색 규율: 주색 1 + 흰 심 1. 접두는 지역과 상관없이 읽혀야 하므로 고정색(신속 청백 · 보호막 푸른 금속 · 분열 자홍).
import type { RegionLook } from '../../render/actors/regionAttach';

export interface FxPalette {
  /** 휘두름·착탄·룬의 주색 */
  readonly main: number;
  /** 흰 심(밝은 쪽) */
  readonly core: number;
  /** 먼지·연기: 지역 바닥색과 명도가 반대(밝은 바닥 = 어두운 먼지, 어두운 바닥 = 밝은 먼지)라 어디서나 묻히지 않는다. 가장자리 테두리는 셰이더가 어둡게 깐다 */
  readonly dust: number;
  /** 바닥 긁힘 자국(돌진 경로): 바닥보다 확실히 어둡거나(밝은 바닥) 밝은(어두운 바닥) 색 */
  readonly scuff: number;
  /** 파편 */
  readonly shard: number;
}

/** 지역 변형 없는 지역(R1·R2·마을 등): 잿불 주황 */
export const PALETTE_DEFAULT: FxPalette = { main: 0xff7a3a, core: 0xfff1d6, dust: 0x5a4632, scuff: 0x3a2a1c, shard: 0x8a6a48 };
export const PALETTE_BY_LOOK: Readonly<Record<RegionLook, FxPalette>> = {
  // 바닥: 서리 = 옅은 푸른 흰색 → 어두운 청회색 먼지 / 독 = 중간 이끼 초록 → 밝은 연노랑 먼지 / 모래 = 밝은 황토 → 어두운 흙갈색 먼지 / 심연 = 어두운 보라 → 밝은 연보라 먼지
  frost: { main: 0x7fd6ff, core: 0xeafaff, dust: 0x4f7298, scuff: 0x35506e, shard: 0xbfe8ff },
  poison: { main: 0x9cff4a, core: 0xf2ffd0, dust: 0xe4f2a8, scuff: 0x1e3314, shard: 0x6aa63a },
  sand: { main: 0xffc85a, core: 0xfff3d0, dust: 0x6e4a28, scuff: 0x4a2f16, shard: 0xd89a34 },
  void: { main: 0xb45cff, core: 0xffd8ff, dust: 0xcdb6ff, scuff: 0xb496f0, shard: 0x7a2fd0 },
};
const BY_MAP: Readonly<Record<string, RegionLook | undefined>> = { r3: 'frost', r4: 'poison', r5: 'sand', r6: 'void' };

export function paletteOfMap(mapId: string): FxPalette {
  const look = BY_MAP[mapId];
  return look ? PALETTE_BY_LOOK[look] : PALETTE_DEFAULT;
}
export function paletteOfLook(look: RegionLook | null): FxPalette {
  return look ? PALETTE_BY_LOOK[look] : PALETTE_DEFAULT;
}

/** 정예 접두 고유색: [0] 없음(쓰지 않음) · 신속 · 보호막 · 분열 */
export const AFFIX_COLOR: readonly number[] = [0xffffff, 0xa8f0ff, 0x6fb4ff, 0xff4f9a];
export const AFFIX_CORE: readonly number[] = [0xffffff, 0xf0ffff, 0xe6f4ff, 0xffd6ea];
